import { useEffect } from 'react';
import { useNotificationsSocket } from '~/utils/websocket.client';

interface NotificationsProviderProps {
  userId: string | undefined;
}

const isClient = typeof window !== 'undefined';

function NotificationsProviderComponent({ userId }: NotificationsProviderProps) {

  const { socket, isConnected, newNotification } = isClient ? useNotificationsSocket(userId) : { socket: null, isConnected: false, newNotification: null };

  useEffect(() => {
    if (isClient && 'Notification' in window) {
      if (Notification.permission !== 'granted' && Notification.permission !== 'denied') {
        Notification.requestPermission().then(permission => {
          console.log('Notification permission status:', permission);
        });
      }
    }
  }, []);

  useEffect(() => {
    if (isConnected) {
      console.log('Connected to WebSocket successfully');
    }
  }, [isConnected]);

  useEffect(() => {
    if (newNotification) {
      console.log('New notification received:', newNotification);
    }
  }, [newNotification]);

  return null; // This component does not render anything
}

// Client-only wrapper component
export const NotificationsProvider = ({ userId }: NotificationsProviderProps) => {
  if (!isClient) {
    return null;
  }

  return <NotificationsProviderComponent userId={userId} />;
}; 